module.exports = __webpack_public_path__ + "static/media/3.3_preview.681d74d1.png";